import { defineComponent as _defineComponent } from 'vue'
import { computed, isRef, onMounted, ref, useAttrs, useSlots } from 'vue';
import { TextInputData } from './types';

interface TextInputProps {
    data: TextInputData;
    moneyOptions?: Record<string, any>;
    onBlur?: (value: any) => void;
    onPaste?: (event: ClipboardEvent) => void;
    onInputReady?: (input: HTMLInputElement | null) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TextInput',
  props: {
    data: null,
    moneyOptions: null,
    onBlur: null,
    onPaste: null,
    onInputReady: null
  },
  emits: ["enter"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'enter'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    data: TextInputData;
    moneyOptions?: Record<string, any>;
    onBlur?: (value: any) => void;
    onPaste?: (event: ClipboardEvent) => void;
    onInputReady?: (input: HTMLInputElement | null) => void;
};



const money = {
    decimal: ',',
    thousands: '.',
    prefix: '',
    suffix: '',
    precision: 2,
    maxlength: 16,
    masked: true
};


const slots = useSlots();
const attrs = useAttrs();
const inputEl = ref<HTMLInputElement | null>(null);

const moneyOptions = computed(() => props.moneyOptions !== undefined ? props.moneyOptions : money);

const value = computed(() => {
    const current = props.data.value;
    const val = isRef(current) ? current.value : current;
    return `${props.data.prepend || ""}${val}${props.data.append || ""}`;
});

const setValue = (value: string | number) => {
    const current = props.data.value;

    if (isRef(current)) {
        current.value = value;
        return;
    }
    props.data.value = value;
};

const handleBlur = (e: any) => {
    if (props.onBlur) {
        props.onBlur(e.target.value);
        return;
    }
};

const handleInput = (event: Event) => {
    const target = event.target as HTMLInputElement;
    setValue(target.value);
};

const handlePaste = (event: ClipboardEvent) => {
    if (props.data.isMoney) {
        onMoneyPaste(event);
    }
    if (props.onPaste) {
        props.onPaste(event);
    }
};

const handleKeyUp = () => {
    emit('enter');
};

const getMoney = (cleaned: string): string => {
    let numericValue: number;
    if (/^\d{1,3}(,\d{3})*(\.\d+)?$/.test(cleaned)) {
        numericValue = parseFloat(cleaned.replace(/,/g, ''));
    } else if (/^\d{1,3}(\.\d{3})*(,\d+)?$/.test(cleaned)) {
        numericValue = parseFloat(cleaned.replace(/\./g, '').replace(',', '.'));
    } else if (/^[\d]+([.,]\d+)?$/.test(cleaned)) {
        numericValue = parseFloat(cleaned.replace(',', '.'));
    } else {
        cleaned = cleaned.replace(/[^\d.,]/g, '');
        const lastComma = cleaned.lastIndexOf(',');
        const lastDot = cleaned.lastIndexOf('.');
        const decimalPos = Math.max(lastComma, lastDot);
        if (decimalPos > -1) {
            const intPart = cleaned.substring(0, decimalPos).replace(/[.,]/g, '');
            const decPart = cleaned.substring(decimalPos + 1);
            numericValue = parseFloat(intPart + '.' + decPart);
        } else {
            numericValue = parseFloat(cleaned);
        }
    }

    if (isNaN(numericValue)) return;

    const precision = money.precision || 2;
    const parts = numericValue.toFixed(precision).split('.');
    const intFormatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const formatted = intFormatted + ',' + parts[1];
    return formatted;
};

const onMoneyPaste = (event: ClipboardEvent) => {
    event.preventDefault();
    const pastedText = (event.clipboardData ? event.clipboardData.getData('text') : '') || '';

    let cleaned = pastedText.trim().replace(/\s/g, '');
    const formatted = getMoney(cleaned);

    setValue(formatted);
    const input = event.target as HTMLInputElement;
    input.value = formatted;
    input.dispatchEvent(new Event('input'));
};

onMounted(() => {
    if (props.onInputReady) {
        props.onInputReady(inputEl.value);
    }
});

return { __sfc: true,props, money, emit, slots, attrs, inputEl, moneyOptions, value, setValue, handleBlur, handleInput, handlePaste, handleKeyUp, getMoney, onMoneyPaste }
}

})